export default __webpack_public_path__ + "static/media/Wave2.f4c4efb8.f4c4efb8.png";